//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: [
    'showInteract'
  ],
  data() {
    return {

    }
  },
  computed: {

  },
  methods: {
    next(id) {
      if (id === 1) {
        document.getElementById('g1').style.display = 'none'
        document.getElementById('g2').style.opacity = 1
      }
      if (id === 2) {
        document.getElementById('g1').style.display = 0
        document.getElementById('g2').style.opacity = 0
        document.getElementById('guide').style.display = "none"
        // 记录用户的localstorage
        window.localStorage.setItem('visited', 'true')
      }
      if (id === 3) {
        document.getElementById('g3').style.opacity = 0
        document.getElementById('guide').style.display = "none"
        // 记录用户的localstorage
        window.localStorage.setItem('visited', 'true')
      }
    }
  },
  components: {

  },
}



// WEBPACK FOOTER //
// ./src/components/Guide/Guide.vue